import { motion } from "framer-motion";
import { TileType } from "../types";

interface Props {
  tile: TileType;
  onClick: (id: number) => void;
  gridSize: number;
  isGameOver: boolean;
}

export default function Tile({ tile, onClick, gridSize, isGameOver }: Props) {
  const base =
    "w-full h-full aspect-square relative rounded-md focus:outline-none";

  const getBackground = () => {
    switch (tile.state) {
      case "preview":
        return "bg-[radial-gradient(circle_at_center,rgba(17,93,44,0.8)_0%,rgba(17,93,44,0.35)_100%)]"; // green preview
      case "found":
        return "bg-[radial-gradient(circle_at_center,rgba(17,93,44,0.8)_0%,rgba(17,93,44,0.35)_100%)]"; // green found, no border
      case "wrong":
        return "bg-[radial-gradient(circle_at_center,rgba(106,45,54,0.8)_0%,rgba(106,45,54,0.45)_100%)]";
      default:
        return "bg-[#686b71]/30 border-[1px] border-white/10"; // hidden default
    }
  };

  const clicked = tile.state === "found" || tile.state === "wrong";

  return (
    <motion.button
      onClick={() => onClick(tile.id)}
      disabled={tile.state === "found" || isGameOver}
      whileTap={{ scale: 0.96 }}
      animate={{ opacity: tile.state === "hidden" ? 0.9 : 1 }}
      transition={{ duration: 0.24 }}
      className={`${base} ${getBackground()} ${
        clicked &&
        `border-[1px] !rounded-none ${
          tile.state === "found"
            ? "border-[#089627]"
            : tile.state === "wrong"
            ? "border-[#FF5656]"
            : "!border-none"
        }`
      } flex items-center justify-center`}
      style={{ padding: gridSize > 6 ? "0.5rem" : "1rem" }}
    >
      {clicked && (
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.25 }}
          className={`
            w-full h-full max-w-[25%] max-h-[25%] rounded-md flex items-center justify-center
            ${tile.state === "wrong" ? "" : "bg-transparent"}
          `}
        >
          {/* Visual dot */}
          {(tile.state === "preview" || tile.state === "found") && (
            <div className="w-full h-full rounded-full bg-[#089627]" />
          )}
          {tile.state === "wrong" && (
            <div className="w-full h-full rounded-full bg-[#FF5656]/80" />
          )}
        </motion.div>
      )}
      {!clicked && (
        <div
          className={`rounded-md border-[1px] w-full h-full flex items-center justify-center  ${
            gridSize > 6 ? "text-xl" : "text-3xl"
          } ${isGameOver ? "border-none" : "border-white/15"}`}
        ></div>
      )}
    </motion.button>
  );
}
